import { trackEvent } from "@pb/utils/tracking";
export const trackAppStoreClick = (appStoreName) => {
    trackEvent({
        event_type: 'ORDER_CONFIRMATION_PL_APP',
        event_category: 'order confirmation interactions',
        event_id: 'pay later download app',
        event_label: appStoreName,
    });
};
export const trackLearnMoreClick = () => {
    trackEvent({
        event_type: 'ORDER_CONFIRMATION_PL_LEARN',
        event_category: 'order confirmation interactions',
        event_id: 'pay later learn more link clicked',
    });
};
//# sourceMappingURL=tracking.js.map